import axios from 'axios';
import Base from './BaseStore';
import { FORCE_COLOR, SVG_PATH } from '../constant';
import draw from '../utils/draw';
const CancelToken = axios.CancelToken;
let source = CancelToken.source();
interface QueryVo {
    subjectId: string;
    pointNum: number;
    edgeLevel: number;
}
interface RequestVo {
    subjectId: string;
    subjectDisplayName: string;
    vertexVoList: {
        vertexMid: string;
        vertexName: string;
        vertexDispalyName: string;
        vertexType: string;
        vertexClassMid: string;
        vertexClassName: string;
        vertexClassDisplayName: string;
        vertexWeight: number;
        userInfoVoList: Array<any>,
        clickable: boolean;
        highlight: boolean;
        applied: boolean;
    }[];
    edgeVoList: {
        vertexMid: string;
        vertexName: string;
        vertexDispalyName: string;
        vertexType: string;
        vertexClassMid: string;
        vertexClassName: string;
        vertexClassDisplayName: string;
        edgePropertyVoList: Array<any>;
        clickable: boolean;
    }[];
    relaTypeVoList: {
        relaName: string;
        relaDisplayName: string;
        relaMid: string;
    }[];
    vertexCategoryVoList: {
        vertexClassMid: string;
        vertexClassName: string;
        vertexClassDisplayName: string;
        categoryNum: number;
    }[];
    userInfoVoList: {
        propertyName: string;
        propertyValue: string;
        display: boolean;
        propertyType: number;
        seqNum: number;
    }[];
}
export interface CategoryVo {
    color: string;
    stroke: string;
    total: number;
    isClick: boolean;
    isDisplay: boolean;
    categoryNum: number;
    vertexClassMid: string;
    vertexClassDisplayName: string;
}
export interface UpEventVo {
    trigger: string;
}
export interface Category {
    [key: string]: CategoryVo;
}
export interface Search {
    [key: string]: Array<NodeVo>;
}
export interface NodeStyleVo {
    size: number;
    stroke: string;
    color: string;
}
export interface NodeVo {
    x: number;
    y: number;
    fx?: number | null;
    fy?: number | null;
    id: string;
    zoomSize: number;
    type: string;
    isLink: string;
    mark: boolean;
    weight: number;
    classMid: string;
    style: NodeStyleVo;
    title: string;
    vertexDisplayName: string;
    el?: SVGElement;
    displayName?: string;
    isDelete?: boolean;
    isClick: boolean;
    highlight: boolean;
    applied: boolean;
    isFraud: boolean;
    isDisplay: boolean;
    userInfoVoList: {
        propertyName: string;
        propertyValue: string;
        display: boolean;
        seqNum: number;
    }[];
}
export interface LinkStyleVo {
    color: string;
}
export interface LinkVo {
    el?: SVGElement;
    style: LinkStyleVo;
    title: string;
    target: NodeVo;
    source: NodeVo;
    isDisplay: boolean;
    edgeMid: string;
    edgePropertyVoList: Array<EdgeVo>;
}
export interface State {
    search: Search;
    category: Category;
    links: Array<LinkVo>;
    nodes: Array<NodeVo>;
}
export interface EdgeVo {
    edgePropertyName: string;
    edgePropertyDisplayName: string;
    edgePropertyMid: string;
    propertyMid: string;
    edgePropertyValue: string;
    seqNum: number;
    display: boolean;
    propertyName?: string;
    propertyValue?: string;
}

class NexusResults extends Base {
    trigger!: string;// 触发数据修改对象
    queueback: any;
    pointNum: number = 10;
    edgeLevel: number = 2;
    dataSource: State = {
        links: [],
        nodes: [],
        search: {},
        category: {}
    };
    isRequest!: boolean;
    rootSubjectId!: string;
    curSubjectId!: string;
    rootUserTitle!: string;
    curNode: NodeVo;
    IndexNode!: {
        [key: string]: number
    };
    queue: {
        [key: string]: Array<Function>
    } = {};
    icon: {
        [key: string]: {
            hover: string;
            normal: string;
        }
    } = {};
    quCache: any;
    dataVersion: string = this.gid();
    constructor() {
        super();
        if (!location.href.includes('finance')) {
            return void 0;
        }
        this.createSvgToIcon();
        this.init();
    }
    get EVENT_UP_DATA(): string {
        return 'event_up_data';
    }
    get EVENT_UP_INIT(): string {
        return 'event_up_init';
    }
    get EVENT_UP_RESET(): string {
        return 'event_up_reset';
    }
    get EVENT_UP_TYPE(): string {
        return 'event_up_type';
    }
    get EVENT_UP_SEARCH(): string {
        return 'event_up_search';
    }
    set UserTitle(data: any) {
        this.rootUserTitle = `${data.classDisplayName} ${data.propertyDisplayName}:${data.objectId}`;
    }
    createSvgToIcon() {
        let fx: number = 0;
        let sum: number = 0;
        const types: any = FORCE_COLOR.type;
        const keys: Array<{
            key: string;
            hover: string;
            normal: string;
        }> = [];
        const doms: Array<string> = [];
        for (const key in types) {
            if (types.hasOwnProperty(key)) {
                let colorD: string = types[key][0];
                let ico: string = SVG_PATH[key][1] || '';
                let colorB: string = 'rgb(255, 255, 255)';
                const colorA: string = types[key][0];
                const colorC: string = 'rgb(255, 255, 255)';
                const d: string = SVG_PATH[key][0];
                if (types[key][2]) {
                    colorD = colorB = types[key][2];
                }
                if (ico) {
                    ico = `<path class="ico" d="${ico}" style="fill: rgb(255, 255, 255); transform: translate(-18px, -18px) scale(1.36);"></path>`;
                }
                keys.push(
                    {
                        key: key,
                        hover: '',
                        normal: ''
                    });
                doms.push(
                    `<g style="transform: translate(${35 + fx}px,35px);">
                        <circle r="35" style="fill: ${colorA};"></circle>
                        <path class="ico" d="${d}" style="fill: ${colorB}; transform: translate(-18px, -18px) scale(1.36);"></path>
                        ${ico}
                        </g>
                    <g style="transform: translate(${35 + fx}px,105px);">
                        <circle r="35" style="fill: ${colorC};"></circle>
                        <path class="ico" d="${d}" style="fill: ${colorD}; transform: translate(-18px, -18px) scale(1.36);"></path>
                        ${ico}
                    </g>`
                );
                fx += 70;
            }
        }
        draw.svgToimg({
            keys,
            html: doms.join(''),
            size: {
                width: 70 * doms.length,
                height: 140
            }
        }, () => {
            draw.config.keys.forEach((vo: {
                key: string;
                hover: string;
                normal: string;
            }) => {
                sum++;
                this.icon[vo.key] = {
                    hover: vo.hover,
                    normal: vo.normal
                };
                if (sum === doms.length && this.queueback) {
                    this.queueback();
                    this.queueback = null;
                }
            });
        });
    }
    init() {
        this.isRequest = false;
        this.dataSource.links = [];
        this.dataSource.nodes = [];
        this.dataSource.search = {};
        this.dataSource.category = {};
        this.IndexNode = {};
        this.rootUserTitle = '';
        this.rootSubjectId = '';
        this.curSubjectId = '';
        this.trigger = '';
        this.curNode = null;
        this.pointNum = 10;
        this.edgeLevel = 2;
    }
    factory(data: RequestVo) {
        this.createCategory(data);
        this.createNode(data);
        this.createLink(data);
        this.update();
        // 默认使用当前节点进行搜索
    }
    /**
     * 切换选中节点
     * @param  {string} id
     */
    swapCurNode(id: string) {
        const node: NodeVo | null = this.findNode(id);
        const upStyle = (node: NodeVo | null, cur: boolean = true) => {
            if (node) {
                const dom: SVGAElement = node.el as SVGAElement;
                const icon: SVGImageElement = dom.querySelector('.icon') as SVGImageElement;
                this.curSubjectId = id;
                if (cur) {
                    icon.setAttribute('href', this.icon[node.type].hover);
                } else {
                    icon.setAttribute('href', this.icon[node.type].normal);
                }
            }
        };
        if (node && node.isClick) {// 节点是否存在
            upStyle(this.findNode(this.curSubjectId), false);
            this.curSubjectId = id;
            upStyle(this.findNode(id));
        }
        this.update(false);
    }
    linkTitle(link: LinkVo) {
        return [link.source, link.target].map((node: NodeVo) => {
            if (node.type !== 'People.User' && node.type !== 'People.loanUser') {
                const vo = node.userInfoVoList[0];
                return `${vo.propertyName}:${vo.propertyValue}`;
            }
            return node.vertexDisplayName;
        });
    }
    filterType(vo: NodeVo) {
        if (vo.type === 'People.User') {
            if (vo.isFraud) { // 类型为用户 并且有欺诈嫌疑
                vo.type = 'People.fraudUser';
            } else if (vo.applied) { // 类型为用户 并且有是否申请生活费
                vo.type = 'People.loanUser';
            }
        }
        return vo;
    }
    createNode(data: RequestVo) {
        const nodes: Array<NodeVo> = this.dataSource.nodes;
        let index: number = nodes.length;
        data.vertexVoList.forEach((vo: any) => {
            let node: NodeVo | null;
            const id: string = vo.vertexMid;
            const { x, y } = this.curNode || { x: 0, y: 0 };
            if (!Reflect.has(this.IndexNode, id) && vo.vertexClassName) { // 不存在的节点进行处理
                node = {
                    id,
                    x,
                    y,
                    zoomSize: 0,
                    type: vo.vertexClassName,
                    mark: false,
                    isLink: vo.vertexType,
                    style: this.createNodeStyle(vo),
                    weight: vo.vertexWeight,
                    classMid: vo.vertexClassMid,
                    title: this.nodeTitle(vo),
                    vertexDisplayName: vo.vertexDisplayName,
                    isDisplay: true,
                    isClick: vo.clickable,
                    highlight: vo.highlight,
                    applied: vo.applied,
                    isFraud: vo.fraud,
                    userInfoVoList: vo.userInfoVoList
                };
                nodes.push(this.filterType(node));
                Reflect.set(this.IndexNode, id, index);
                index++;
            } else {// 如果新的请求里面存在相同节点将其开启
                const i: number = Reflect.get(this.IndexNode, id);
                if (Reflect.has(this.dataSource.nodes, i)) {
                    this.dataSource.nodes[Reflect.get(this.IndexNode, id)].isDisplay = true;
                }
            }
        });
    }
    /**
     * 返回节点标题
     * 判断是否为主节点并且当前类型为用户进行单独处理
     * @param  {any} vo
     */
    nodeTitle(vo: any) {
        let title: string;
        const type: string = vo.vertexClassName;
        if (vo.vertexMid === this.rootSubjectId && type === 'People.User') {
            title = this.rootUserTitle || vo.vertexDisplayName || '';
        }
        title = vo.vertexDisplayName || '';
        const index: number = title.indexOf(':');
        if (type !== 'People.User' && index !== -1) {
            return title.substr(index + 1);
        }
        return title;
    }
    filterNetwork(id: string, map?: { [key: string]: NodeVo }): { [key: string]: NodeVo } {
        const links: Array<LinkVo> = [...this.dataSource.links];
        const nodeMap: { [key: string]: NodeVo } = map || {};
        if (!map) {
            this.dataSource.nodes.map((node: NodeVo) => {
                if (node.id !== id) {
                    Reflect.set(nodeMap, node.id, node);
                }
            });
        }
        const task = (id: string) => {
            if (Reflect.has(nodeMap, id)) {
                Reflect.deleteProperty(nodeMap, id);
                for (let i = 0; i < links.length; i++) {
                    const link: LinkVo = links[i];
                    if (link) {
                        if (link.source.id === id) {
                            task(link.target.id);
                        }
                        if (link.target.id === id) {
                            task(link.source.id);
                        }
                    }
                }
            }
        };
        task(this.rootSubjectId);
        return nodeMap;
    }
    /**
     * 查询返回当前节点下面是否存在一级节点
     * 没有节点与节点被隐藏
     * @param  {string} id
     * @returns number -1 存在隐藏节点 0 没有节点 1 全部隐藏
     */
    isNetwork(id: string) {
        let type: number = -1;
        let isDisplay: boolean = false;
        const dataSource: { [key: string]: NodeVo } = this.filterNetwork(id);
        const keys: Array<string> = Object.keys(dataSource);
        for (let i = 0; i < keys.length; i++) {
            if (!dataSource[keys[i]].isDisplay) {
                isDisplay = true;
                break;
            }
        }
        type = keys.length;
        if (isDisplay) {
            return -1;
        }
        return type;
    }
    lightAllNode(opacity: string) {
        this.dataSource.nodes.forEach((node: NodeVo) => {
            const dom: SVGAElement = node.el as SVGAElement;
            if (dom) {
                dom.style.opacity = opacity;
            }
        });
        this.dataSource.links.forEach((link: LinkVo) => {
            const dom: SVGAElement = link.el as SVGAElement;
            if (dom) {
                dom.style.opacity = opacity;
            }
        });
    }
    lightLink(link: LinkVo) {
        this.lightAllNode('0.1');
        let dom: SVGAElement = link.el as SVGAElement;
        if (dom) {
            dom.style.opacity = '1';
            dom = link.target.el as SVGAElement;
            dom.style.opacity = '1';
            dom = link.source.el as SVGAElement;
            dom.style.opacity = '1';
        }
    }
    lightNode(id: string) {
        const kmap: { [key: string]: boolean } = { [id]: true };
        const node: NodeVo | null = this.findNode(id);
        const setStyle = (link: LinkVo, opacity: string) => {
            let dom: SVGAElement = link.el as SVGAElement;
            if (dom) {
                dom.style.opacity = opacity;
            }
            dom = link.source.el as SVGAElement;
            if (dom) {
                dom.style.opacity = opacity;
            }
            dom = link.target.el as SVGAElement;
            if (dom) {
                dom.style.opacity = opacity;
            }
        };
        if (node) {
            this.lightAllNode('0.1');
            this.findAllNode(id, false, true).forEach((node: NodeVo) => {
                Reflect.set(kmap, node.id, true);
            });
            this.dataSource.links.forEach((link: LinkVo) => {
                if (link.target.id === id) {
                    Reflect.set(kmap, link.source.id, true);
                }
                if (Reflect.has(kmap, link.target.id)) {
                    setStyle(link, '1');
                }
            });
        }
    }
    freezeNode(node?: NodeVo | null, thaw: boolean = true) {
        const freeze = (node: NodeVo, thaw: boolean) => {
            if (thaw) {
                node.fx = null;
                node.fy = null;
            } else {
                node.fx = node.x;
                node.fy = node.y;
            }
        };
        if (node) {
            freeze(node, thaw);
        } else {
            this.dataSource.nodes.forEach((node: NodeVo) => freeze(node, thaw));
        }
    }
    appendNode(id: string) {
        if (this.findNode(id)) {
            switch (this.isNetwork(id)) {
            case 0:
                this.request({
                    pointNum: 10,
                    edgeLevel: 1,
                    subjectId: id
                });
                break;
            case -1:
                this.swapCurNode(id);// 显示节点
                this.displayShowNode(id);
                break;
            default:
                this.swapCurNode(this.rootSubjectId);// 隐藏节点更新到主节点
                this.displayHideNode(id);
                break;
            }
        }
    }
    sumWeight(data: number): number {
        return Math.floor(10 + (25 - 10) * 40 / 100);
    }
    createNodeStyle(vo: any): NodeStyleVo {
        const id: string = vo.vertexMid;
        const classMid: string = vo.vertexClassMid;
        let size: number = 34;
        let color: string = '#0A9DB2';
        let stroke: string = '#0E1F21';
        if (id !== this.rootSubjectId) {// 子节点类型颜色
            size = this.sumWeight(vo.vertexWeight);
            color = this.dataSource.category[classMid].color;
            stroke = this.dataSource.category[classMid].stroke;
        }
        return {
            size,
            color,
            stroke
        };
    }
    createSearch(id: string) {
        const search: Search = {};
        this.dataSource.links.forEach((link: LinkVo) => {
            this.searchMatrix(id, link, search);
            // const source: NodeVo = link.source;
            // const target: NodeVo = link.target;
            // if (source.id === id || target.id === id) {
            //     // const key: string = link.title;
            //     const key: string = link.edgeMid;
            //     const result: Array<NodeVo> = Reflect.get(search, key) || [];
            //     if (!Reflect.has(search, key)) {
            //         Reflect.set(search, key, result);
            //     }
            //     if (source.id === id) {
            //         result.push(target);
            //     }
            //     if (target.id === id) {
            //         result.push(source);
            //     }
            // }
        });
        this.curSubjectId = id;
        this.dataSource.search = search;
    }
    ruleQuire(data: {
        attribute: string;
        condition: string;
        display: boolean;
        type: number;
        value: any;
    }[]) {
        let count: number = 0;
        const dataSource: { [key: string]: {sign: boolean; sum: number } } = {};
        const size: number = data.length;
        /**
         * 判断属性列表是否存在指定的节点对象
         * @param data
         * @param mid
         */
        const isNode = (data: any[], mid: string) => {
            for (let i = 0; i < data.length; i++) {
                const vo: any = data[i];
                if (mid === vo.propertyMid) {
                    return vo;
                }
            }
            return null;
        };
        /**
         * 判断当前节点是否是用户属性节点
         * @param node
         */
        const isUser = (node: NodeVo) => {
            switch (node.type) {
            case 'People.User':
            case 'People.loanUser':
            case 'People.fraudUser':
                return true;
            default:
                break;
            }
            return true;
        };
        const rSign = () => {
            for (const key in dataSource) {
                if (dataSource.hasOwnProperty(key)) {
                    dataSource[key].sign = false;
                }
            }
        };
        /**
         * 验证是否被标记 如果被标记加一
         * @param key
         */
        const hasKey = (key: string) => {
            if (Reflect.has(dataSource, key)) {
                const data: any = Reflect.get(dataSource, key);
                if (!data.sign) { // 存在被第二轮规则标记
                    data.sign = true;
                    data.sum += 1;
                }
                Reflect.set(dataSource, key, data);
            } else { // 没有被标记过
                Reflect.set(dataSource, key, { sign: true, sum: 1 });
            }
        };
        /**
         * 查找一级相关用户节点
         * @param node
         */
        const lookUser = (node: NodeVo) => {
            const id: string = node.id;
            const links: LinkVo[] = this.dataSource.links;
            for (let i = 0; i < links.length; i++) {
                const { target, source } = links[i];
                if (target.id === id && isUser(source)) {
                    hasKey(source.id);
                }
                if (source.id === id && isUser(target)) {
                    hasKey(target.id);
                }
            }
        };
        /**
         * 执行逻辑判断结果
         * @param kValue
         * @param condition
         * @param value
         */
        const working = (kValue: string, condition: string, value: string) => {
            let bool: boolean = false;
            switch (condition) {
            case '=':
                bool = kValue === value;
                break;
            case '≠':
                bool = kValue !== value;
                break;
            case '>':
                bool = kValue > value;
                break;
            case '<':
                bool = kValue < value;
                break;
            case '≤':
                bool = kValue <= value;
                break;
            default:
                break;
            }
            return bool;
        };
        /**
         * 执行筛选
         * @param vo
         */
        const lookUpOR = (vo: any) => {
            const kValue: string = vo.value;
            const mid: string = vo.attribute;
            const condition: string = vo.condition;
            const nodes: Array<NodeVo> = this.dataSource.nodes;
            for (let i = 0; i < nodes.length; i++) {
                const node: NodeVo = nodes[i];
                const user = isNode(node.userInfoVoList, mid); // 判断用户信息列表满足
                if (user) { // 规则筛选
                    if (working(user.propertyValue, condition,kValue)) {
                        lookUser(node);
                    }
                }
            }
        };
        const lookUpAND = (vo: any, nodes: Array<NodeVo>) => {
            const mid: string = vo.attribute;
            const kValue: string = vo.value;
            const condition: string = vo.condition;
            return nodes.filter((node: NodeVo) => {
                if (isUser(node)) { // 规则筛选
                    const user = isNode(node.userInfoVoList, mid); // 判断用户信息列表满足
                    if (user && working(user.propertyValue, condition,kValue)) {
                        return true;
                    }
                }
                return false;
            });
        };
        const lookUpLink = (vo: any) => {
            const mid: string = vo.attribute;
            const kValue: string = vo.value;
            const condition: string = vo.condition;
            this.dataSource.links.forEach((link: LinkVo) => {
                const { source } = link;
                if (isUser(source)) {
                    const user = isNode(link.edgePropertyVoList, mid); // 判断边是否满足条件
                    if (user && working(user.propertyValue, condition,kValue)) {
                        hasKey(source.id);// 源头一定是人
                    }
                }
            });
        };
        if (size > 0) {
            let nodes: Array<NodeVo> = this.dataSource.nodes;
            const types: any[][] = [];
            data.forEach((vo: any) => {
                const index: number = vo.type;
                if (!types[index]) {
                    types[index] = [];
                }
                types[index].push(vo);
            });
            types.forEach((vo: any[]) => {
                if (vo) {
                    count++;
                    rSign();
                    vo.forEach((item: any) => {
                        switch (item.type) {
                        case 0:
                            lookUpOR(item);
                            break;
                        case 1:
                            nodes = lookUpAND(item, nodes);
                            break;
                        case 2:
                            lookUpLink(item);
                            break;
                        case 3:
                            lookUpLink(item);
                            break;
                        default:
                            break;
                        }
                    });
                }
            });
            if (types[1]) {
                nodes.forEach((node: NodeVo) => {
                    hasKey(node.id);
                });
            }
            Reflect.set(dataSource, 'count', count);
            Reflect.set(dataSource, 'querys', data);
            this.quCache = dataSource;
            this.quLighting();
        } else {
            this.quCache = null;
            this.lightAllNode('1');
        }
    }
    quLighting() {
        if (this.quCache) {
            const count: number = Reflect.get(this.quCache, 'count') || 0;
            this.lightAllNode('0.1');
            this.dataSource.nodes.forEach((node: NodeVo) => {
                if (Reflect.has(this.quCache, node.id)) {
                    const { sum } = Reflect.get(this.quCache, node.id);
                    if (sum >= count) {
                        const dom: SVGAElement = node.el as SVGAElement;
                        if (dom) {
                            dom.style.opacity = '1';
                        }
                    }
                }
            });
        }
    }
    searchMatrix(nodeId: string, link: LinkVo, search: Search) {
        //  ['1069573876075204707']
        const keys: string[][] = [
            ['1069573876075204702', '1069573876075204705'],
            ['1069573876075204710', '1069573876075204713'],
            ['1069573876075204707', '1069573876075204700', '1069573876075204701'] // 1069573876075204700 没有接收短信
        ];
        const eachList = (edgePropertyMid: string, data: EdgeVo[]) => {
            for (let i = 0; i < data.length; i++) {
                const vo: EdgeVo = data[i];
                if (edgePropertyMid === vo.edgePropertyMid && vo.edgePropertyValue === '是') {
                    return true;
                }
            }
            return false;
        };
        const eachMobile = (source: NodeVo, target: NodeVo) => {
            let mobile: NodeVo;
            if (source.type === 'Location.MobileNumber') {
                mobile = source;
            }
            if (target.type === 'Location.MobileNumber') {
                mobile = target;
            }
            if (mobile) {
                const data = mobile.userInfoVoList;
                const size: number = mobile.userInfoVoList.length;
                if (size) {
                    for (let i = 0; i < data.length; i++) {
                        const vo = data[i];
                        if (vo.propertyName === '最近接收美团短信是否成功' && vo.propertyValue === '是') {
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        keys.forEach((vo: string[]) => {
            let edgeMid: string = vo[0];
            const size: number = vo.length;
            if (link.edgeMid === edgeMid) {
                const source: NodeVo = link.source;
                const target: NodeVo = link.target;
                if (source.id === nodeId || target.id === nodeId) {
                    const edgeList: EdgeVo[] = link.edgePropertyVoList;
                    if (link.edgePropertyVoList.length > 0) { // 判断是否可以读取边属性
                        if (size === 2 && eachList(vo[1], edgeList)) {
                            edgeMid = vo[1];
                        }
                    }
                    if (size === 3) {// 设备接收短信 没有单独的ID号 前端虚拟的ID号
                        edgeMid = vo[1];
                        if (eachMobile(source, target)) {// 关联手机号确定是否接收短信 去节点查找
                            edgeMid = vo[2];
                        }
                    }
                    const result: Array<NodeVo> = Reflect.get(search, edgeMid) || [];
                    if (!Reflect.has(search, edgeMid)) {
                        Reflect.set(search, edgeMid, result);
                    }
                    if (source.id === nodeId) {
                        result.push(target);
                    }
                    if (target.id === nodeId) {
                        result.push(source);
                    }
                }
            }
        });
    }
    findSearch(word: string): Search {
        const result: Search = {};
        const search: Search = this.dataSource.search;
        for (let [key, data] of Object.entries(search)) {
            if (key.indexOf(word) !== -1) {
                Reflect.set(result, key, data);
            }
        }
        return result;
    }
    createLinkTips(data: Array<EdgeVo>): Array<EdgeVo> {
        data.map((vo: EdgeVo) => {
            vo.propertyName = vo.edgePropertyDisplayName;
            vo.propertyValue = vo.edgePropertyValue;
            vo.propertyMid = vo.edgePropertyMid;
            return vo;
        });
        return data;
    }
    createLink(data: RequestVo) {
        const links: Array<LinkVo> = this.dataSource.links;
        data.edgeVoList.forEach((vo: any) => {
            links.push({
                isDisplay: true,
                edgeMid: vo.edgeMid,
                style: this.createLinkStyle(vo),
                title: vo.edgeDisplayName,
                source: vo.sourceVertexMid,
                target: vo.targetVertexMid,
                edgePropertyVoList: this.createLinkTips(vo.edgePropertyVoList)
            });
        });
    }
    createLinkStyle(vo: any): LinkStyleVo {
        return {
            color: '#5072F3'
        };
    }
    createCategory(data: RequestVo) {
        const category: Category = this.dataSource.category;
        data.vertexCategoryVoList.forEach((vo: any, index: number) => {
            const mid: string = vo.vertexClassMid;
            const type: string = vo.vertexClassName;
            if (!Reflect.has(category, mid) && type) {
                const colors: Array<string> = FORCE_COLOR.type[type];
                Reflect.set(category, mid, {
                    categoryNum: 0,
                    isClick: false,
                    isDisplay: false,
                    color: colors[0],
                    stroke: colors[1],
                    vertexClassMid: vo.vertexClassMid,
                    vertexClassDisplayName: vo.vertexClassDisplayName
                });
            }
        });
    }
    groupCategory() {
        const category: Category = this.dataSource.category;
        for (let [, vo] of Object.entries(category)) {
            vo.total = 0;
            vo.categoryNum = 0;
            vo.isDisplay = false;
        }
        this.dataSource.nodes.forEach((node: NodeVo) => {
            if (node.id !== this.rootSubjectId) { // 根节点不计入统计
                if (Reflect.has(category, node.classMid)) {// 节点是否可以见 并且存在于类型里面
                    category[node.classMid].total += 1;
                    if (node.isDisplay) {
                        category[node.classMid].isDisplay = true;
                        category[node.classMid].categoryNum += 1;
                        node.displayName = category[node.classMid].vertexClassDisplayName;
                    }
                }
            }
        });
    }
    groupNode(): Array<NodeVo> {
        return this.dataSource.nodes.filter((node: NodeVo) => {
            if (node.isDisplay) {
                return true;
            }
            return false;
        });
    }
    groupLink(): Array<LinkVo> {
        return this.dataSource.links.filter((link: LinkVo) => link.isDisplay);
    }
    reset() {
        this.quCache = null;
        this.init();
        this.dispatch(this.EVENT_UP_RESET, {
            trigger: 'default'
        });
        this.update();
    }
    dispatch(type: string, ev: UpEventVo) {
        (this.queue[type] || []).forEach((callback: Function) => callback(ev));
    }
    gid(): string {
        return 'xxxxxx4xxyxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }).toUpperCase();
    }
    on(type: string, callback: Function) {
        if (type in this.queue) {
            this.queue[type].push(callback);
        } else {
            this.queue[type] = [callback];
        }
    }
    /**
     * 更新数据
     * @param  {boolean=true} isUpMap 是否发送渲染事件通知进行渲染
     */
    update(isUpMap: boolean = true) {
        this.curNode = this.findNode(this.curSubjectId || this.rootSubjectId);
        this.dataVersion = this.gid();
        this.groupCategory();
        this.displayLink();
        const ev: UpEventVo = {
            trigger: this.trigger || 'default'
        };
        isUpMap && this.dispatch(this.EVENT_UP_DATA, ev);
        // 监听到数据改变更新节点
        this.createSearch(this.curSubjectId || this.rootSubjectId);
        this.dispatch(this.EVENT_UP_TYPE, ev);
        this.dispatch(this.EVENT_UP_SEARCH, ev);
        this.trigger = '';
        if (this.quCache) {
            if (isUpMap) {
                this.ruleQuire(this.quCache.querys);
            } else {
                this.quLighting();
            }
        } else {
            this.lightAllNode('1');
        }
    }
    clearNode(id: string) {
        let node: NodeVo;
        const nodes: Array<NodeVo> = this.dataSource.nodes;
        const links: Array<LinkVo> = this.dataSource.links;
        this.findAllNode(id).forEach((node: NodeVo) => {
            Reflect.deleteProperty(this.IndexNode, node.id);
            node.isDelete = true;
        });
        for (let i = links.length - 1; i > -1; i--) {
            node = links[i].target;
            if (node.isDelete) {
                links.splice(i, 1);
            }
        }
        for (let i = nodes.length - 1; i > -1; i--) {
            node = nodes[i];
            if (nodes[i].isDelete) {
                nodes.splice(i, 1);
            }
        }
    }
    deleteNode(id: string) {
        let node: NodeVo;
        let link: LinkVo;
        const nodes: Array<NodeVo> = this.dataSource.nodes;
        const links: Array<LinkVo> = this.dataSource.links;
        const dataSource: { [key: string]: NodeVo } = this.filterNetwork(id);
        this.freezeNode(this.findNode(id), false);
        for (let i = links.length - 1; i > -1; i--) {
            link = links[i];
            node = link.target;
            if (Reflect.has(dataSource, node.id)) {
                links.splice(i, 1);
            }
            node = link.source;
            if (Reflect.has(dataSource, node.id)) {
                links.splice(i, 1);
            }
        }
        for (let i = nodes.length - 1; i > -1; i--) {
            node = nodes[i];
            if (Reflect.has(dataSource, node.id)) {
                nodes.splice(i, 1);
                Reflect.deleteProperty(this.IndexNode, node.id);
            }
        }
    }
    /**
     * 更新查询条件之后需要清除之前的节点信息
     * 存在当修改的为子节点的时候去除数据会有问题
     * @param  {number} pointNum
     * @param  {number} edgeLevel
     */
    upQuire(pointNum: number, edgeLevel: number) {
        const subjectId: string = this.curSubjectId;
        this.deleteNode(subjectId);
        this.dispatch(this.EVENT_UP_INIT, {
            trigger: 'init'
        });
        this.request({
            pointNum,
            edgeLevel,
            subjectId
        });
    }
    findAllNode(id: string, display: boolean = false, isOwn: boolean = false, result: Array<NodeVo> = []) {
        const node: NodeVo | null = this.findNode(id);
        const links: Array<LinkVo> = this.dataSource.links;
        const find = (id: string): boolean => {
            if (id === this.rootSubjectId) {
                return true;
            }
            for (let i = 0; i < links.length; i++) {
                let source: NodeVo = links[i].source;
                // 没有下一级子节点
                if (source.id === id) {
                    if (display) {
                        if (source.isDisplay) {
                            return true;
                        }
                        return false;
                    }
                    return true;
                }
            }
            return false;
        };
        const task: Function = (id: string) => {
            if (find(id)) {
                for (let i = 0; i < links.length; i++) {
                    let source: NodeVo = links[i].source;
                    let target: NodeVo = links[i].target;
                    if (source.id === id) {
                        result.push(target);
                        task(target.id);
                    }
                }
            }
        };
        task(id);
        if (isOwn && node) {
            result.push(node);
        }
        return result;
    }
    /**
     *
     * @param id
     * @param isWhile
     * @param isOwn
     * @param result
     */
    filterNode(id: string, isWhile: boolean = true, isOwn: boolean = true, result: Array<NodeVo> = []) {
        const node: NodeVo | null = this.findNode(id);
        const links: Array<LinkVo> = this.dataSource.links;
        const find = (id: string): boolean => {
            if (id === this.rootSubjectId) {
                return true;
            }
            for (let i = 0; i < links.length; i++) {
                let link: LinkVo = links[i];
                let source: NodeVo = link.source;
                let target: NodeVo = link.target;
                // 判断是否被标记过 标记过不在递归
                if (target.isDisplay && source.id === id) {
                    return true;
                }
            }
            return false;
        };
        const task: Function = (id: string) => {
            if (find(id)) {
                for (let i = 0; i < links.length; i++) {
                    let source: NodeVo = links[i].source;
                    let target: NodeVo = links[i].target;
                    if (source.id === id && target.isDisplay) {
                        result.push(target);
                        if (isWhile) {
                            task(target.id);
                        }
                    }
                }
            }
        };
        task(id);
        if (isOwn && node) {
            result.push(node);
        }
        return result;
    }
    findNode(id: string): NodeVo | null {
        if (Reflect.has(this.IndexNode, id)) {
            const index: number = Reflect.get(this.IndexNode, id);
            return this.dataSource.nodes[index];
        }
        return null;
    }
    displayShowNode(id: string) {
        // 标记孤立节点
        const dataSource: { [key: string]: NodeVo } = this.filterNetwork(id);
        for (let [, node] of Object.entries(dataSource)) {
            node.isDisplay = true;
        }
        this.update();
    }
    displayHideNode(id: string, isTarget: boolean = false) {
        const dataSource: { [key: string]: NodeVo } = this.filterNetwork(id);
        for (let [, node] of Object.entries(dataSource)) {
            node.isDisplay = false;
        }
        this.update();
    }
    displayLink() {
        this.dataSource.links.forEach((link: LinkVo) => {
            if (link.el) {
                link.isDisplay = link.source.isDisplay && link.target.isDisplay;
            }
        });
    }
    /**
     * 传入需要展示的节点ID集合
     * @param id
     * @param keys
     */
    displaySearch(id: string, data: Array<string>) {
        // 标记孤立节点
        const keys: { [key: string]: boolean } = {};
        const target: { [key: string]: NodeVo } = {};
        const search: Search = this.dataSource.search;
        data.forEach((key: string) => {
            Reflect.set(keys, key, true);
        });
        for (let [key, nodes] of Object.entries(search)) {
            if (Reflect.has(keys, key)) {// 去缓存里面找到搜索分类下面对于的节点ID
                nodes.forEach((node: NodeVo) => { // 将节点ID写入搜索
                    Reflect.set(target, node.id, node);
                });
            }
        }
        const dataSource: { [key: string]: NodeVo } = this.filterNetwork(this.curSubjectId);
        for (let [, node] of Object.entries(dataSource)) {
            if (Reflect.has(target, node.id)) {
                node.isDisplay = true;
            } else {
                node.isDisplay = false;
            }
        }
        this.update();
    }
    filterLink(id: string): Array<LinkVo> {
        return this.dataSource.links.filter((link: LinkVo) => {
            if (link.isDisplay && link.source.id === id) {
                return true;
            }
            return false;
        });
    }
    groupGrid() {
        const nodes: Array<NodeVo> = this.dataSource.nodes.filter((node: NodeVo) => node.isDisplay);
        const dataSource: Array<any> = [];
        nodes.forEach((node: NodeVo) => {
            const entity: string = node.title;
            const links: Array<LinkVo> = this.filterLink(node.id);
            if (links.length) {
                const list: Array<{
                    entity: string;
                    nexus: string;
                    type: string;
                    instance: string;
                    cvt: string;
                }> = [];
                dataSource.push(list);
                links.forEach((link: LinkVo) => {
                    const targetNode: NodeVo = link.target;
                    const nexus: string = targetNode.displayName || '主节点';
                    const type: string = link.title;
                    const instance: string = targetNode.title;
                    const cvt: string = '需要和产品确定CVT是什么';
                    list.push({
                        entity, type, nexus, instance, cvt
                    });
                });
            }
        });
        return dataSource;
    }
    displayCategory(classMid: string, isDisplay: boolean, trigger: string) {
        const source: { [key: string]: NodeVo } = {};
        const target: { [key: string]: NodeVo } = {};
        const category: Category = this.dataSource.category;
        this.trigger = trigger;
        // 切换了类型当前节点切换到跟节点
        this.curSubjectId = this.rootSubjectId;
        category[classMid].isDisplay = isDisplay;
        this.dataSource.nodes.forEach((node: NodeVo) => {
            const vo: CategoryVo = category[node.classMid];
            if (node.classMid === classMid) {
                node.isDisplay = isDisplay;
            }
            if (vo && vo.isDisplay && node.isDisplay) {
                Reflect.set(source, node.id, node);
            } else {
                Reflect.set(target, node.id, node);
            }
            node.isDisplay = true;
        });
        Reflect.set(source, this.rootSubjectId, Reflect.get(target, this.rootSubjectId));
        Reflect.deleteProperty(target, this.rootSubjectId);
        const dataSource: { [key: string]: NodeVo } = Object.assign(target, this.filterNetwork(this.rootSubjectId, source));
        for (let [, node] of Object.entries(dataSource)) {
            node.isDisplay = false;
        }
        this.update();
    }
    async request(params: QueryVo, isCombine: boolean = false) {
        const queue = async() => {
            try {
                if (!this.isRequest) {
                    this.isRequest = true;
                    this.pointNum = params.pointNum;
                    this.edgeLevel = params.edgeLevel;
                    // const res: any = mock;
                    const res: any = await this.$api({
                        method: 'get',
                        path: `/finance-api/v1/financeRelationMap`,
                        cancelToken: source.token,
                        params
                    });
                    if (!this.rootSubjectId) {
                        this.curSubjectId = this.rootSubjectId = params.subjectId;
                    }
                    this.curSubjectId = params.subjectId;
                    if (res.code === 200) {
                        this.factory(res.data as RequestVo);
                    } else {
                        this.$showMessage(res.message);
                    }
                } else {
                    source.cancel();
                    source = CancelToken.source();
                }
                this.isRequest = false;
            } catch (error) {
                this.isRequest = false;
                this.$showMessage(JSON.stringify(error));
            }
            return this.dataSource;
        };
        if (Object.keys(this.icon).length) {// 处理生成小图标异步时间
            queue();
        } else {
            this.queueback = queue;
        }
    }
}
export default new NexusResults();
